import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { watchVerifyPhoneSaga } from './saga';
import { SignupState, VerifyPhonePayload } from './types';
import { FailureResponse } from 'types/api';

export const initialState: SignupState = {
  phone: '',
  isLoading: false,
  signupFailureResponse: null,
  signupSuccessResponse: null,
};

export const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    signup(state, action: PayloadAction<VerifyPhonePayload>) {
      state.isLoading = true;
      state.signupFailureResponse = null;
      state.signupSuccessResponse = null;
    },
    signupSuccess(
      state,
      action: PayloadAction<{ goto: string; access_token: string }>,
    ) {
      state.isLoading = false;
      state.signupSuccessResponse = action.payload;
    },
    signupFailure(state, action: PayloadAction<FailureResponse | null>) {
      state.isLoading = false;
      state.signupFailureResponse = action.payload;
    },
    signupReset(state) {
      state.isLoading = false;
      state.signupFailureResponse = null;
      state.signupSuccessResponse = null;
    },
  },
});

export const { actions: signupActions } = signupSlice;

export const useSignupSlice = () => {
  useInjectReducer({ key: signupSlice.name, reducer: signupSlice.reducer });
  useInjectSaga({ key: signupSlice.name, saga: watchVerifyPhoneSaga });
  return { actions: signupSlice.actions };
};
